import { AnyObject, string, StringSchema } from "yup"
import { MESSAGE_ERREUR_REGEXP_TELEPHONE } from "../../data/message-erreurs-form" 

// Format international E.164: +[code pays][numéro]
const regexTelephoneInternational = /^\+[1-9]\d{1,14}$/;

export const telephoneSchemaRequired = (message: string): StringSchema<string, AnyObject, undefined> => string()
    .transform((value) => value ? value : undefined)
  .matches(regexTelephoneInternational, MESSAGE_ERREUR_REGEXP_TELEPHONE)
  .required(message);
